import { render, staticRenderFns } from "./PostTypeDrawer.vue?vue&type=template&id=caf1e836&scoped=true&"
import script from "./PostTypeDrawer.vue?vue&type=script&lang=js&"
export * from "./PostTypeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PostTypeDrawer.vue?vue&type=style&index=0&id=caf1e836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf1e836",
  null
  
)

export default component.exports